<template>
    <section>
        <h2 v-if="paid"><span class="text-success"><i class="fa fa-check"></i></span> Payment successful</h2>
        <h2 v-if="error"><span class="text-error"><i class="fa fa-warning-sign"></i></span> Payment failed</h2>
        <p v-if="error">Make sure you have enabled online payments on your card and that the transaction limit allows for this amount.</p>
        <small v-if="error" class="muted">
            <p>
                If the problem persists, please send this error message to our <a href="/support">support team</a>:
                {{message}}
            </p>
        </small>
        <Payment v-if="!paid" ref="payment" :callback="paidDeposit" :query="query" :type="'report'" :price="price" />
        <br>
        <button class="btn btn-default" @click="close">Back</button>
    </section>
</template>

<script>
    import Vue from 'vue'
    import Payment from '../components/Payment'

    export default {
        name: 'ReportCheckout',
        components: {
            Payment
        },
        data () {
            return {
                paid: false,
                error: false,
                message: '',
                price: null,
                query: {}
            }
        },
        methods: {
            paidDeposit (resp) {
                if (resp.result) {
                    this.paid = true
                } else {
                    this.error = true
                }
                this.message = resp.message
            },
            close () {
                window.close()
            }
        },
        created () {
            this.price = this.$parent.price
            this.query = this.$parent.query
            Vue.nextTick().then(() => {
                this.$refs.payment.show()
            })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/ritekit/ReportCheckout.vue